import React from "react";
import ReactDOM from "react-dom";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, useLocation, Navigate } from "react-router-dom";
import App from "./App";
import "./assets/css/a_font-awesome-5.9.0.css";
import "./assets/css/b_bootstrap.min.css";
import "./assets/css/c_magnific-popup.css";
import "./assets/css/d_flaticon.css";
import "./assets/css/e_slick.css";
import "./assets/css/main.css";
import "./assets/css/style.css";
import reportWebVitals from "./reportWebVitals";

// Component to handle all trailing slash redirects
function TrailingSlashHandler({ children }) {
  const location = useLocation();
  
  // If path ends with slash and is not root, redirect
  if (location.pathname.endsWith('/') && location.pathname !== '/') {
    const newPath = location.pathname.slice(0, -1) + location.search;
    return <Navigate to={newPath} replace />;
  }
  
  return children;
}

ReactDOM.render(
  <HelmetProvider>
    <BrowserRouter>
      <TrailingSlashHandler>
        <App />
      </TrailingSlashHandler>
    </BrowserRouter>
  </HelmetProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
